import { useEffect, useState } from "react";
import { useFormContext } from "./provider";

const isObject = (val: any) => {
  return val != null && typeof val === "object" && Array.isArray(val) === false;
};

const getFirstErrorKey = (
  object: Record<string, any>,
  defaultFirstKey?: string,
  keys: Array<string> = []
): [string, string] => {
  const objectKeys = Object.keys(object);

  const firstErrorKey =
    objectKeys.find((key) => key === defaultFirstKey) || objectKeys[0];
  if (isObject(object[firstErrorKey])) {
    return getFirstErrorKey(object[firstErrorKey], defaultFirstKey, [
      ...keys,
      firstErrorKey,
    ]);
  }
  return [
    [...keys, firstErrorKey].join("."),
    [...keys, firstErrorKey].join("-"), // This is mainly for date fields which use the - do separate the name of fields
  ];
};

export const ScrollOnError = ({
  defaultKeys,
}: {
  defaultKeys?: Array<string>;
}) => {
  const formy = useFormContext();

  const [submitCount, setSubmitCount] = useState(formy.submitCount);

  useEffect(() => {
    if (!formy.isValid && formy.submitCount > submitCount) {
      if (defaultKeys) {
        for (const defaultKey of defaultKeys) {
          const [firstErrorKey, alternativeErrorKey] = getFirstErrorKey(
            formy.errors,
            defaultKey
          );

          if (document.getElementsByName(firstErrorKey).length) {
            document.getElementsByName(firstErrorKey)[0].focus();
            break;
          } else if (document.getElementsByName(alternativeErrorKey).length) {
            document.getElementsByName(alternativeErrorKey)[0].focus();
            break;
          }
        }
      } else {
        const [firstErrorKey, alternativeErrorKey] = getFirstErrorKey(
          formy.errors,
          undefined
        );

        if (document.getElementsByName(firstErrorKey).length) {
          document.getElementsByName(firstErrorKey)[0].focus();
        } else if (document.getElementsByName(alternativeErrorKey).length) {
          document.getElementsByName(alternativeErrorKey)[0].focus();
        }
      }

      setSubmitCount(formy.submitCount);
    }
  }, [
    defaultKeys,
    formy.errors,
    formy.isValid,
    formy.submitCount,
    submitCount,
  ]);
  return null;
};
